
    // IMPORTS
    import { computed, defineComponent } from 'vue';
    import { RouterView } from 'vue-router'

    import PortalPage from '@/components/common/portal-page.vue'
    import { buildLocalization, DEBUG_ENABLED } from '@/util'
    import { INavigationItem } from '@/types/INavigationItem'

    export default defineComponent({
        name: 'adminView',

        components: {
            PortalPage,
            RouterView
        },

        setup() {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            const { localize } = buildLocalization();

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const navigationItems = computed(() => [
                { textName: 'Equipments', routeName: 'admin-equipment-list', replace: true },
                { textName: 'OrderProposals', routeName: 'admin-order-proposals', replace: true },
                { textName: 'SpareParts', routeName: 'admin-spare-parts', replace: true },
                { textName: 'Users', routeName: 'admin-user-list', replace: true },
                { textName: 'Partners', routeName: 'admin-partner-list', replace: true },
                { textName: 'SynchronizationService', routeName: 'admin-sync-events-list', replace: true },
                {
                    textName: 'Swagger',
                    routeFunction: () => window.open('https://localhost:5001/swagger', '_blank', 'noopener'),
                    condition: () => DEBUG_ENABLED,
                    align: 'right'
                }
            ] as INavigationItem[])

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { localize, navigationItems }
        }
    });
